export default {
    Id: '',
    Name: '',
    OfficeId: '',
    OwnerLegalEntityId: '',
}